import api from './api';
import API from './apiconfig';
import { getBrowserDebugInfo } from './upiDeepLink';

export const PAYMENT_ATTEMPT_SESSION_KEY = 'iconnect_payment_attempt_session';

const PLAN_TYPE_API = {
  emi: 'monthly_emi',
  full: 'full_settlement',
};

export function getStoredPaymentAttemptSessionId() {
  try {
    return sessionStorage.getItem(PAYMENT_ATTEMPT_SESSION_KEY);
  } catch {
    return null;
  }
}

export function storePaymentAttemptSessionId(sessionId) {
  try {
    if (sessionId) {
      sessionStorage.setItem(PAYMENT_ATTEMPT_SESSION_KEY, sessionId);
    }
  } catch {
    /* ignore storage errors */
  }
}

export function clearPaymentAttemptSessionId() {
  try {
    sessionStorage.removeItem(PAYMENT_ATTEMPT_SESSION_KEY);
  } catch {
    /* ignore */
  }
}

/** Start or reuse a server-side payment attempt audit session. */
export async function ensurePaymentAttemptSession({
  selectedPlan = 'emi',
  planName = '',
  amountLabel = '',
  installmentNo = null,
} = {}) {
  const existing = getStoredPaymentAttemptSessionId();
  if (existing) return existing;

  const payload = {
    plan_type: PLAN_TYPE_API[selectedPlan] || PLAN_TYPE_API.emi,
    plan_name: planName,
    expected_amount: amountLabel,
    device: getBrowserDebugInfo(),
  };
  if (installmentNo != null) payload.installment_no = installmentNo;

  const res = await api.post(API.PAYMENT_ATTEMPT_CREATE, payload);
  const sessionId = res.data?.session_id;
  if (!sessionId) {
    throw new Error('Payment audit session was not created.');
  }
  storePaymentAttemptSessionId(sessionId);
  return sessionId;
}

/** Record a lifecycle event (UPI open, return, cancel, fail). Best-effort — never blocks UX. */
export async function recordPaymentAttemptEvent(sessionId, event, extra = {}) {
  if (!sessionId) return null;
  try {
    const res = await api.post(API.PAYMENT_ATTEMPT_EVENT(sessionId), {
      event,
      device: getBrowserDebugInfo(),
      ...extra,
    });
    return res.data;
  } catch {
    return null;
  }
}

export { PLAN_TYPE_API };
